// 금천아 빌려줘 — 담당자 메모 (목록 카드·상세 공용)
//
// ⚠️ ERP 전용 필드다(카페24로 나가지 않는다). 저장은 PATCH rental/orders/{id}/ { memo }
//    하나뿐이고, 수정자·시각은 서버가 채운다(api.partial_update).
// ⚠️ 동기화는 메모를 건드리지 않는다 — 화면이 목록을 다시 불러와도 서버 값 그대로다.
import React, { useEffect, useState } from "react";

import api from "../../api";
import { formatDateTime } from "./format";

// view="list"(목록 카드)면 저장 응답도 목록 형태로 받는다 — 메모 속 번호가 가려진 채로.
export default function RentalMemo({ order, onSaved, className = "", view }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(order.memo || "");
  const [saving, setSaving] = useState(false);
  const [savedFlash, setSavedFlash] = useState(false);
  const [error, setError] = useState("");

  // 바깥에서 주문이 새로 들어오면(목록 새로고침 등) 편집 중이 아닐 때만 맞춘다 —
  // 편집 중에 덮으면 쓰던 내용이 사라진다.
  useEffect(() => {
    if (!editing) setDraft(order.memo || "");
  }, [order.memo, editing]);

  const startEdit = () => {
    setDraft(order.memo || "");
    setError("");
    setEditing(true);
  };

  const cancel = () => {
    setDraft(order.memo || "");
    setError("");
    setEditing(false);
  };

  const save = async () => {
    setSaving(true);
    setError("");
    try {
      const query = view === "list" ? "?view=list" : "";
      const res = await api.patch(`rental/orders/${order.id}/${query}`, { memo: draft });
      setEditing(false);
      setSavedFlash(true);
      setTimeout(() => setSavedFlash(false), 2000);
      if (onSaved) onSaved(res.data);
    } catch (e) {
      setError(e?.response?.data?.detail || "메모를 저장하지 못했습니다.");
    } finally {
      setSaving(false);
    }
  };

  const hasMemo = Boolean((order.memo || "").trim());

  return (
    <div className={`rental-card__memo ${className}`.trim()}>
      {editing ? (
        <>
          <textarea
            className="rental-card__memo-input"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="내부 메모 — 카페24로 나가지 않습니다"
            autoFocus
            disabled={saving}
          />
          {/* 메모 속 번호는 가려져 있다(서버 door.mask_memo) — 그대로 두면 원래 번호로 저장된다 */}
          {order.memo_masked && (
            <div className="rental-card__memo-hint">●●●●는 원래 번호로 저장됩니다</div>
          )}
          <div className="rental-card__memo-actions">
            {error && <span className="rental-card__memo-error">{error}</span>}
            <button
              type="button"
              className="rental-card__memo-btn"
              onClick={cancel}
              disabled={saving}
            >
              취소
            </button>
            <button
              type="button"
              className="rental-card__memo-btn rental-card__memo-btn--save"
              onClick={save}
              disabled={saving}
            >
              {saving ? "저장 중…" : "저장"}
            </button>
          </div>
        </>
      ) : hasMemo ? (
        <button
          type="button"
          className="rental-card__memo-view"
          onClick={startEdit}
          title="눌러서 수정"
        >
          <span className="rental-card__memo-label">메모</span>
          <span className="rental-card__memo-text">{order.memo}</span>
        </button>
      ) : (
        <button type="button" className="rental-card__memo-add" onClick={startEdit}>
          + 메모 추가
        </button>
      )}

      {!editing && (savedFlash || order.memo_updated_at) && (
        <div className="rental-card__memo-meta">
          {savedFlash ? (
            <span className="rental-card__memo-saved">저장 완료</span>
          ) : (
            <>
              {order.memo_updated_by_name || "-"} · {formatDateTime(order.memo_updated_at)}
            </>
          )}
        </div>
      )}
    </div>
  );
}
